import React from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import ElectronicDPNCreateForm from './ElectronicDPNCreateForm';
import useTranslation from '../../../../../Hooks/useTranslation';
import { useTreatmentContext } from '../../../../../Services/TreatmentContext';

interface Props {
	opened: boolean;
	onClose: (needReload: boolean) => void;
	patientIdentifier: string;
	electronicConfirmation?: any;
}

const ElectronicDPNCreateModal: React.FC<Props> = props => {
	const { opened, onClose, patientIdentifier, electronicConfirmation } = props;

	const { t } = useTranslation();
	const { isCase } = useTreatmentContext();

	return (
		<Modal
			opened={opened}
			onClose={() => onClose(false)}
			fullScreen={false}
			wrapChat={isCase}>
			<Modal.Header title='nczi.electronicDPN.create.title' firstUpper />
			<Modal.Content>
				<ElectronicDPNCreateForm
					onClose={onClose}
					patientIdentifier={patientIdentifier}
					electronicConfirmation={electronicConfirmation}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default ElectronicDPNCreateModal;
